import TreatmentsSection from './treatments-section';
import templateOnly from '@ember/component/template-only';
import Patient from 'core/models/patient';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const codes = patient1 => {
  return ['nephro-transplant', 'cardio-heart-failure', 'pneumo-transplant', 'hepato-transplant', 'cardio-transplant', 'onco-ovarian-cancer', 'onco-pancreatic-cancer', 'onco-testicular-cancer', 'onco-prostate-cancer', 'onco-lymphoma-cancer', 'onco-stomach-cancer', 'onco-myeloma-cancer', 'nephro-mrc', 'onco-kidney-cancer', 'onco-hemato-cancer', 'onco-lung-cancer', 'onco-cervix-cancer', 'onco-breast-cancer', 'onco-breast-cancer-tnm0', 'onco-liver-cancer', 'onco-skin-cancer', 'onco-colon-cancer', 'onco-brain-cancer'].includes(patient1.followUpReason) ? ['B03X'] : [];
};
const TreatmentsFields = setComponentTemplate(precompileTemplate("\n  {{#let (codes @patient) as |codes|}}\n    {{#if codes.length}}\n      {{yield (component TreatmentsSection codes=codes)}}\n    {{/if}}\n  {{/let}}\n", {
  strictMode: true,
  scope: () => ({
    codes,
    TreatmentsSection
  })
}), templateOnly(undefined, "treatments-fields:TreatmentsFields"));
export default TreatmentsFields;